import { render } from "./fans.vue?vue&type=template&id=4bbc7ce7&scoped=true"
import script from "./fans.vue?vue&type=script&lang=js"
export * from "./fans.vue?vue&type=script&lang=js"

import "./fans.vue?vue&type=style&index=0&id=4bbc7ce7&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbc7ce7"]])

export default __exports__